import { slugify } from './slugify.cjs';

export const getPressReleaseLink = (slug) => {
  return `/if-magazine/newsroom/${slugify(slug, true)}`;
};

export const getPressReleaseDownloadImagesLink = () => {
  return `/if-magazine/newsroom/download-images`;
};

export const getPressReleaseDownloadImagePackagesLink = () => {
  return `/if-magazine/newsroom/download-image-packages`;
};

export const getPressReleaseDownloadNewsletterDocumentsLink = () => {
  return `/if-magazine/newsroom/download-newsletter-documents`;
};
